<template>
  <button @click="toggleState()" class="btn btn-small btn-secondary">
    {{ this.deadline.is_done ? 'wieder öffnen' : 'erledigt' }}
  </button>
</template>

<script>
export default {
  props: ['deadline'],
  data() {
    return {
      isDoneFilter: false,
    }
  },
  methods: {
    toggleState: function () {
      this.$http['put']('/deadlines/' + this.deadline.id + '.json', {
        deadline: {is_done: !this.deadline.is_done},
      }).then(response => {
        this.deadlines = response.body
        this.$emit('updated')
        Vue.$toast.success('Frist wurde verschoben.')
      }, response => {
        console.log(response)
      })
    }
  },
  mounted() {
    //this.fetchData();
  }
}
</script>